// 配達先情報 CRUD (/pages/address). Chờ ink:api:ready → list + add/edit
// form → CONFIRM (address-confirm.html) → PUT/POST + delete (soft)
// + zip lookup + pref dropdown. Fail-open.

(function () {
  'use strict';

  function boot() {
    const root = document.querySelector('[data-ink-address]');
    if (!root) return;
    const listEl = root.querySelector('[data-address-list]');
    const form = root.querySelector('[data-address-form]');
    const prefSel = form.querySelector('select[name=pref_cd]');
    const msg = form.querySelector('[data-address-msg]');
    const title = form.querySelector('[data-form-title]');
    const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const setVal = (n, v) => { const el = form.elements[n]; if (el) el.value = v == null ? '' : v; };

    async function loadPrefs() {
      try { const j = await window.inkApi.get('/prefectures'); const items = (j && j.data) || []; prefSel.innerHTML = '<option value="">選択</option>' + items.map((p) => `<option value="${p.pref_cd}">${p.pref_name}</option>`).join(''); } catch (e) { /* */ }
    }

    async function loadList() {
      let j;
      try { j = await window.inkApi.get('/addresses', { sort: 'id' }); } catch (e) {
        root.querySelector('[data-address-guest]')?.classList.remove('hidden'); listEl.innerHTML = ''; return;
      }
      const items = (j && j.data) || [];
      if (!items.length) { listEl.innerHTML = '<div class="rounded border border-dashed border-ink-grayLine bg-gray-50 p-6 text-center text-sm text-gray-700">配達先未登録です。</div>'; return; }
      // 5.3: コンビニ受取先 (combini_flg=1) HIỆN nhưng LOCK — bỏ nút 変更/削除 (gắn với đơn/
      // cửa hàng, user KHÔNG tự sửa được), thêm badge コンビニ受取 + ghi chú.
      const card = (a) => {
        const locked = Number(a.combini_flg) === 1;
        const badge = locked ? '<span class="ml-2 rounded bg-gray-500 px-2 py-0.5 align-middle text-xs font-bold text-white">コンビニ受取</span>' : '';
        const actions = locked
          ? '<p class="shrink-0 self-center text-xs leading-5 text-gray-500">コンビニ受取先は<br class="hidden sm:block">変更・削除できません</p>'
          : `<div class="flex shrink-0 gap-2">
              <button type="button" data-edit class="inline-flex min-h-10 items-center justify-center rounded border border-ink-blue px-4 text-sm font-bold text-ink-blue">変更</button>
              <button type="button" data-delete class="min-h-10 rounded border border-gray-400 px-4 text-sm font-bold text-gray-700">削除</button>
            </div>`;
        return `
        <div class="rounded border ${locked ? 'border-ink-grayLine bg-gray-50' : 'border-ink-grayLine bg-white'} p-4" data-receiver-id="${a.receiver_id}"${locked ? ' data-locked="1"' : ''}>
          <div class="flex flex-wrap items-start justify-between gap-3">
            <div>
              <p class="text-lg font-bold">${esc(a.label || a.name)}${badge}</p>
              <p class="mt-2 text-sm leading-6 text-gray-700">${esc(a.name)}${a.kana ? `（${esc(a.kana)}）` : ''}<br>〒${esc(a.zip_1)}-${esc(a.zip_2)} ${esc(a.pref_name || '')}${esc(a.city)}${esc(a.town)} ${esc(a.building || '')}${a.phone ? `<br>TEL: ${esc(a.phone)}` : ''}</p>
            </div>
            ${actions}
          </div>
        </div>`;
      };
      listEl.innerHTML = items.map(card).join('');
    }

    const confirmPanel = root.querySelector('[data-address-confirm]');
    const confirmBody = root.querySelector('[data-address-confirm-body]');
    const confirmMsg = root.querySelector('[data-address-confirm-msg]');
    // listview = nút 新規登録 + danh sách. Ẩn khi add/edit/confirm → chỉ hiện MÀN EDIT
    // (design address-edit.html = trang riêng, không có list).
    const listview = root.querySelector('[data-address-listview]');
    const formSkeleton = root.querySelector('[data-address-form-skeleton]');
    const showListview = () => listview?.classList.remove('hidden');
    const hideListview = () => listview?.classList.add('hidden');
    const hideSkeleton = () => formSkeleton?.classList.add('hidden');

    function hideConfirm() { confirmPanel?.classList.add('hidden'); if (confirmMsg) confirmMsg.textContent = ''; }
    function showForm(mode) { hideConfirm(); hideListview(); hideSkeleton(); title.textContent = mode === 'edit' ? '配達先を編集' : '配達先を追加'; form.classList.remove('hidden'); msg.textContent = ''; window.scrollTo({ top: 0, behavior: 'smooth' }); }
    function hideForm() { form.classList.add('hidden'); hideSkeleton(); form.reset(); setVal('receiver_id', ''); hideConfirm(); showListview(); }

    root.querySelector('[data-address-add]')?.addEventListener('click', () => { form.reset(); setVal('receiver_id', ''); showForm('add'); });
    form.querySelector('[data-address-cancel]')?.addEventListener('click', hideForm);

    async function openEdit(id) {
      // Chờ GET /addresses/{id} → hiện SKELETON (rule §Loading state), ẩn list + form.
      hideListview(); hideConfirm(); form.classList.add('hidden'); formSkeleton?.classList.remove('hidden');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      try {
        const j = await window.inkApi.get(`/addresses/${id}`); const d = j && j.data;
        if (!d) { hideSkeleton(); showListview(); return; }
        // 5.3: コンビニ受取先 KHÔNG cho sửa (kể cả khi vào bằng ?edit= trên URL).
        if (Number(d.combini_flg) === 1) { hideSkeleton(); window.alert('コンビニ受取先は変更できません。'); showListview(); return; }
        ['label', 'name', 'kana', 'zip_1', 'zip_2', 'city', 'town', 'building', 'phone', 'company', 'brew', 'shipment_note'].forEach((k) => setVal(k, d[k]));
        prefSel.value = String(d.pref_cd || '');
        setVal('receiver_id', d.receiver_id);
        showForm('edit'); // hideSkeleton bên trong
      } catch (err) { hideSkeleton(); showListview(); }
    }

    listEl.addEventListener('click', async (e) => {
      const card = e.target.closest('[data-receiver-id]'); if (!card) return;
      const id = card.dataset.receiverId;
      if (e.target.matches('[data-edit]')) {
        await openEdit(id);
      } else if (e.target.matches('[data-delete]')) {
        if (!window.confirm('この配達先を削除してよろしいですか？')) return;
        window.inkProcessing?.show();
        let j;
        try { j = await window.inkApi.delete(`/addresses/${id}`); } finally { window.inkProcessing?.hide(); }
        // Success = 204 no body → client trả {data:null}. Lỗi transport (network/
        // parse/HTTP rỗng) mang `error`; lỗi nghiệp vụ (Shopify delete fail →
        // rollback, địa chỉ còn nguyên) mang `errors`/`message` từ Laravel (ADR-020).
        if (j && j.error) {
          window.alert('削除に失敗しました。');
        } else if (j && (j.errors || j.message)) {
          const errs = j.errors ? Object.values(j.errors).flat() : [j.message];
          window.alert(errs.join('\n') || '削除に失敗しました。');
        } else {
          // Xóa OK (204 no body) → toast để user nắm bắt (list view không có slot inline).
          window.inkToast?.('配達先を削除しました。');
        }
        await loadList();
      }
    });

    // 郵便番号: 全角数字 → 半角 + bỏ ký tự không phải số (Joomla zip2Addr.js:7-8), để khách
    // không gặp lỗi 「半角数字」 khó hiểu. Chờ IME chốt chữ mới đổi (đổi giữa chừng phá IME);
    // dán 「185-0003」 vào ô đầu thì tách sang ô sau.
    const toHalfDigits = (v) => String(v || '').replace(/[０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xfee0)).replace(/[^0-9]/g, '');
    const bindZipInput = (first, second) => {
      const clean = (el) => {
        const v = toHalfDigits(el.value).slice(0, el.maxLength > 0 ? el.maxLength : 7);
        if (v === el.value) return false;
        el.value = v;
        return true;
      };
      [first, second].forEach((el) => {
        el.addEventListener('input', (e) => { if (!e.isComposing) clean(el); });
        ['compositionend', 'blur'].forEach((type) => el.addEventListener(type, () => {
          if (clean(el)) el.dispatchEvent(new Event('input', { bubbles: true }));
        }));
      });
      first.addEventListener('paste', (e) => {
        const v = toHalfDigits(e.clipboardData?.getData('text'));
        if (v.length !== 7) return;
        e.preventDefault();
        first.value = v.slice(0, 3);
        second.value = v.slice(3);
        second.dispatchEvent(new Event('input', { bubbles: true }));
      });
    };
    bindZipInput(form.elements.zip_1, form.elements.zip_2);

    const zipMsg = root.querySelector('[data-zip-msg]');
    const showZipMsg = (t) => { if (zipMsg) { zipMsg.textContent = t; zipMsg.classList.toggle('hidden', !t); } };
    let zipDone = '';
    async function lookupZip() {
      const z = ((form.elements.zip_1.value || '') + (form.elements.zip_2.value || '')).replace(/[^0-9]/g, '');
      if (z.length !== 7 || z === zipDone) return;
      zipDone = z;
      showZipMsg('');
      try {
        const j = await window.inkApi.get(`/zip/${z}`);
        const d = j && j.data;
        if (d) { if (d.pref_cd) prefSel.value = String(d.pref_cd); setVal('city', d.city); setVal('town', d.town); }
        else if (j && j.error) { zipDone = ''; console.warn('zip lookup error', j.error); } // network → im lặng
        else { zipDone = ''; showZipMsg('郵便番号が見つかりません。'); } // 404 = không có mã này
      } catch (e) { zipDone = ''; console.warn('zip lookup fail', e); }
    }
    form.elements.zip_1.addEventListener('input', lookupZip);
    form.elements.zip_2.addEventListener('input', lookupZip);
    root.querySelector('[data-zip-lookup]')?.addEventListener('click', () => { zipDone = ''; lookupZip(); });

    // Autokana: お名前(name) → tự sinh フリガナ(kana) khi gõ IME.
    window.inkBindAutokana?.(form.elements.name, form.elements.kana);

    function collectPayload() {
      const payload = {};
      ['label', 'name', 'kana', 'zip_1', 'zip_2', 'pref_cd', 'city', 'town', 'building', 'phone', 'company', 'brew', 'shipment_note'].forEach((k) => { payload[k] = form.elements[k] ? form.elements[k].value : ''; });
      payload.pref_cd = parseInt(payload.pref_cd, 10) || '';
      return payload;
    }

    // Confirm — design address-confirm.html: <dl> grid 2 cột, 住所 gộp
    // 都道府県+市区町村+町名+建物 như design; +配送指示 (field theme). Hàng cuối không border-b.
    function buildConfirm(payload) {
      const prefName = payload.pref_cd && prefSel.selectedOptions[0] ? prefSel.selectedOptions[0].textContent : '';
      const addr = `${prefName}${payload.city || ''}${payload.town || ''} ${payload.building || ''}`.trim();
      const rows = [
        ['配達先名', esc(payload.label)],
        ['お名前', esc(payload.name)],
        ['フリガナ', esc(payload.kana)],
        ['郵便番号', `${esc(payload.zip_1)}-${esc(payload.zip_2)}`],
        ['住所', esc(addr)],
        ['電話番号', esc(payload.phone)],
        ['会社名', esc(payload.company)],
        ['部署名', esc(payload.brew)],
      ];
      if (payload.shipment_note) rows.push(['配送指示', esc(payload.shipment_note).replace(/\n/g, '<br>')]);
      const html = rows.map(([label, value], i) => {
        const last = i === rows.length - 1;
        // border-ink-grayLine LUÔN có để border-r/border-b cùng màu xám (tránh dòng cuối
        // border-r đen currentColor = vạch đậm bất thường).
        const b = last ? '' : 'border-b ';
        return `<dt class="border-ink-grayLine ${b}bg-gray-50 px-4 py-3 font-bold sm:border-r">${label}</dt><dd class="border-ink-grayLine ${b}px-4 py-3">${value}</dd>`;
      }).join('');
      confirmBody.innerHTML = `<dl class="grid overflow-hidden rounded border border-ink-grayLine text-sm sm:grid-cols-[180px_1fr]">${html}</dl>`;
    }

    // Submit form = mở CONFIRM (design: 入力漏れ → không cho qua màn confirm; validate đủ ở server khi 登録).
    let pendingPayload = null;
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const payload = collectPayload();
      const missing = [['name', 'お名前'], ['kana', 'フリガナ'], ['zip_1', '郵便番号'], ['zip_2', '郵便番号'], ['pref_cd', '都道府県'], ['city', '市区町村'], ['town', '町名・番地'], ['phone', '電話番号']]
        .filter(([k]) => !String(payload[k] || '').trim()).map(([, label]) => label);
      if (missing.length) {
        msg.textContent = `必須項目をご入力ください：${[...new Set(missing)].join(' / ')}`;
        msg.className = 'mt-3 text-sm text-ink-red';
        return;
      }
      msg.textContent = '';
      pendingPayload = payload;
      buildConfirm(payload);
      form.classList.add('hidden');
      confirmPanel.classList.remove('hidden');
      confirmPanel.scrollIntoView({ behavior: 'smooth' });
    });

    root.querySelector('[data-address-confirm-back]')?.addEventListener('click', () => {
      hideConfirm();
      form.classList.remove('hidden');
      form.scrollIntoView({ behavior: 'smooth' });
    });

    // この内容で登録する → PUT/POST thật (logic submit cũ giữ nguyên, chỉ dời sang confirm).
    root.querySelector('[data-address-confirm-submit]')?.addEventListener('click', async () => {
      if (!pendingPayload) return;
      confirmMsg.textContent = '';
      const id = form.elements.receiver_id.value;
      window.inkProcessing?.show();
      let j;
      try { j = id ? await window.inkApi.put(`/addresses/${id}`, pendingPayload) : await window.inkApi.post('/addresses', pendingPayload); } finally { window.inkProcessing?.hide(); }
      if (j && j.data && j.data.receiver_id) {
        // Báo thành công TRƯỚC khi đóng (đừng đóng im lặng) → reload list.
        confirmMsg.textContent = '保存しました。'; confirmMsg.className = 'mt-3 text-center text-sm font-bold text-[#01b245]';
        // Khách từ khối chọn 配送先 ở giỏ sang đây là để sửa sổ địa chỉ rồi quay lại
        // chọn — xong việc mà thả họ lại ở 配達先一覧 là bắt tự tìm đường về. Cả thêm
        // lẫn sửa, vì `return_to=cart` chỉ có khi họ đi từ giỏ sang.
        const back = returnToCart();
        if (back) {
          window.location.href = back;

          return;
        }
        await loadList();
        setTimeout(() => { hideForm(); confirmMsg.className = 'mt-3 text-center text-sm text-ink-red'; }, 900);
      } else {
        const errs = j && j.errors ? Object.values(j.errors).flat() : null;
        confirmMsg.textContent = errs ? errs.join(' / ') : ((j && j.message) || '保存に失敗しました。');
        confirmMsg.className = 'mt-3 text-center text-sm text-ink-red';
      }
    });

    // Chỉ nhận đúng chuỗi `cart`, KHÔNG nhận URL tuỳ ý trên query: nhận URL là mở
    // đường redirect sang tên miền khác bằng một link dán vào chat.
    function returnToCart() {
      if (new URLSearchParams(window.location.search).get('return_to') !== 'cart') return '';

      return root.dataset.cartUrl || '/cart';
    }

    // prefs TRƯỚC (để openEdit set pref dropdown đúng) → list → mở edit nếu có ?edit
    (async () => {
      const editId = new URLSearchParams(window.location.search).get('edit');
      // ?edit= → ẩn listview + hiện SKELETON NGAY (tránh flash list + màn trắng lúc chờ API).
      if (editId && /^[0-9]+$/.test(editId)) { hideListview(); formSkeleton?.classList.remove('hidden'); }
      await loadPrefs();
      await loadList();
      if (editId && /^[0-9]+$/.test(editId)) openEdit(editId);
    })();
  }

  let booted = false;
  function startOnce() { if (booted) return; booted = true; boot(); }
  if (window.inkApi) startOnce();
  else { document.addEventListener('ink:api:ready', startOnce, { once: true }); window.addEventListener('load', () => setTimeout(() => { if (!window.inkApi) startOnce(); }, 1000)); }
})();
